export function normalizeJobFlagValue(value) {
	if (typeof value === "boolean") {
		return value;
	}
	if (typeof value === "number") {
		return value === 1;
	}
	if (typeof value === "string") {
		return ["1", "true", "yes", "y", "on"].indexOf(value.trim().toLowerCase()) !== -1;
	}
	return false;
}

function hasRushSticker(stickers) {
	return Array.isArray(stickers) && stickers.some(sticker => (
		sticker && String(sticker.label || "").trim().toLowerCase() === "rush"
	));
}

export function isRushJobHit(hit = {}) {
	if (Object.prototype.hasOwnProperty.call(hit, "rushJob")) {
		return normalizeJobFlagValue(hit.rushJob);
	}
	return hasRushSticker(hit.stickers);
}

export function isGuaranteedJobHit(hit = {}) {
	return normalizeJobFlagValue(hit.guaranteedJob);
}

export function isEstimateNeededHit(hit = {}) {
	return normalizeJobFlagValue(hit.ccEstimateYesNo);
}

function updateJobFlagItems(children, itemId, answer) {
	if (!Array.isArray(children)) {
		return 0;
	}

	return children.reduce((matchCount, item) => {
		if (!item || typeof item !== "object") {
			return matchCount;
		}

		let nextMatchCount = matchCount;
		if (item.id === itemId) {
			item.value = answer;
			nextMatchCount++;
		}
		return nextMatchCount + updateJobFlagItems(item.children, itemId, answer);
	}, 0);
}

export function setJobFlagAnswer(checklist = {}, itemId, enabled) {
	if (!checklist || typeof checklist !== "object" || !itemId) {
		return checklist;
	}

	const answer = enabled ? "yes" : "no";
	const itemMatchCount = updateJobFlagItems(checklist.children, itemId, answer);
	const variable = checklist.variables && checklist.variables[itemId];
	if (variable && typeof variable === "object") {
		variable.value = answer;
	} else if (checklist.variables && Object.prototype.hasOwnProperty.call(checklist.variables, itemId)) {
		checklist.variables[itemId] = answer;
	}

	// Older procedures may not contain the yes/no item. The indexer uses this
	// same-named top-level value as its fallback in that case.
	if (itemMatchCount === 0 || Object.prototype.hasOwnProperty.call(checklist, itemId)) {
		checklist[itemId] = enabled;
	}

	return checklist;
}

function getActiveJobFlagColors(rushJob, guaranteedJob, estimateNeeded) {
	return [
		rushJob ? "#c62828" : null,
		guaranteedJob ? "#1565c0" : null,
		estimateNeeded ? "#ef6c00" : null
	].filter(Boolean);
}

export function getJobFlagAccent(rushJob, guaranteedJob, estimateNeeded) {
	const colors = getActiveJobFlagColors(rushJob, guaranteedJob, estimateNeeded);
	if (colors.length === 0) {
		return "transparent";
	}
	if (colors.length === 1) {
		return colors[0];
	}

	const segmentSize = 100 / colors.length;
	const colorStops = colors.map((color, index) => {
		const start = index * segmentSize;
		const end = (index + 1) * segmentSize;
		return `${color} ${start}%, ${color} ${end}%`;
	});
	return `linear-gradient(90deg, ${colorStops.join(", ")})`;
}

export function getJobFlagInsetShadow(rushJob, guaranteedJob, estimateNeeded) {
	const colors = getActiveJobFlagColors(rushJob, guaranteedJob, estimateNeeded);
	if (colors.length === 0) {
		return "none";
	}
	if (colors.length === 1) {
		return `inset 7px 0 0 ${colors[0]}`;
	}
	return colors.map((color, index) => `inset ${(index + 1) * 4}px 0 0 ${color}`).join(", ");
}
